import React, { useContext } from "react";
import clsx from "clsx";
import WebProfileContext from "@WebProfileContext";
import Typography from "@material-ui/core/Typography";

import styles from "./Address.styles";

const Address = () => {
	const css = styles();
	const [profileData] = useContext(WebProfileContext);
	const { mail, phone } = profileData;

	return (
		<div className={clsx(css.address, "mco-view-component-footer-address")}>
			<div className={clsx(css.content, "mco-view-component-footer-address__content")}>
				<div>
					<p>{profileData?.name}</p>
					<p>{profileData?.street}</p>
					<p>
						A-{profileData?.zip} {profileData?.city}
					</p>
				</div>
				{phone && (
					<Typography className={css.phone} variant="h4" component="p">
						<a href={"tel:" + phone?.replace(/ /g, "")}>{phone}</a>
					</Typography>
				)}
				{mail && (
					<Typography className={css.mail} variant="h4" component="p">
						<a href={"mailto:" + mail}>{mail}</a>
					</Typography>
				)}
			</div>
		</div>
	);
};

export default Address;
